import { render, staticRenderFns } from "./TestingStatistics.vue?vue&type=template&id=69381bad&scoped=true"
import script from "./TestingStatistics.vue?vue&type=script&lang=js"
export * from "./TestingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69381bad",
  null
  
)

export default component.exports